// extracted by mini-css-extract-plugin
export default {"detail_table":"Table_detail_table__aZSf8"};